import Content from "../../help/mrp-runs.mdx";

export function MrpRunsHelpPage() {
  return <Content />;
}
